import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { hubPathForRole, normalizeApiRole } from '@/lib/routing';

/**
 * @param {{ allowedRoles: string[]; children: React.ReactNode }} props
 */
export function RoleRoute({ allowedRoles, children }) {
  const { authHydrated, user } = useApp();
  const location = useLocation();

  if (!authHydrated) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-muted-foreground text-sm">
        Memuat sesi…
      </div>
    );
  }

  const role = normalizeApiRole(user.role);
  if (!user.isLoggedIn || !user.id || !allowedRoles.includes(role)) {
    const dest = hubPathForRole(role);
    return <Navigate to={dest} replace state={{ from: location }} />;
  }

  return children;
}
